import { Stack, Typography } from "@mui/material";

const SensorInfo = ({ isTablet, instrumentsData }) => {
  return (
    <Stack direction="column">
      <Typography fontWeight="bold" fontSize="12px">
        {instrumentsData.nickname}
      </Typography>
      <Typography fontWeight="bold" fontSize={isTablet ? "24px" : "32px"}>
        {`${instrumentsData.value || ""} ${instrumentsData.unit || ""}`}
      </Typography>
    </Stack>
  );
};

export default SensorInfo;
